import { patientBaseModel } from './crud';
import { fetchNextContactSyncByPatientId } from './fetchNextContactSyncByPatientId';

export * from './usePatientLogin';
export * from './usePatientVerify';

export * from './types';

export const usePatientsById = patientBaseModel.fetchById();
export const usePatientsByIds = patientBaseModel.fetchByIds();
export const usePatientsMany = patientBaseModel.fetchMany();
export const usePatientsCount = patientBaseModel.count();
export const usePatientsManyInfiniteQuery = patientBaseModel.fetchPaginated();
export const usePatientsUpdateOne = patientBaseModel.edit();
export const usePatientsCreateOne = patientBaseModel.create();
export const usePatientsRemoveOne = patientBaseModel.delete();
export const usePatientsRemoveByIds = patientBaseModel.deleteByIds();

export const usePatientsByIdV2 = patientBaseModel.fetchByIdV2();
export const usePatientsByIdsV2 = patientBaseModel.fetchByIdsV2();
export const usePatientsManyV2 = patientBaseModel.fetchManyV2();
export const usePatientsCountV2 = patientBaseModel.countV2();
export const usePatientsManyInfiniteQueryV2 =
  patientBaseModel.fetchPaginatedV2();
export const usePatientsUpdateOneV2 = patientBaseModel.editV2();
export const usePatientsCreateOneV2 = patientBaseModel.createV2();
export const usePatientsRemoveOneV2 = patientBaseModel.deleteV2();
export const usePatientsRemoveByIdsV2 = patientBaseModel.deleteByIdsV2();

export const useFetchNextContactSyncByPatientId =
  fetchNextContactSyncByPatientId();

// New names based on Mongoose queries
export const usePatientById = patientBaseModel.fetchById();
export const usePatientByIds = patientBaseModel.fetchByIds();
export const usePatientMany = patientBaseModel.fetchMany();
export const usePatientCount = patientBaseModel.count();
export const usePatientPagination = patientBaseModel.fetchPaginated();
export const usePatientUpdateOne = patientBaseModel.edit();
export const usePatientCreateOne = patientBaseModel.create();
export const usePatientRemoveOne = patientBaseModel.delete();
export const usePatientRemoveByIds = patientBaseModel.deleteByIds();

export const usePatientByIdV2 = patientBaseModel.fetchByIdV2();
export const usePatientByIdsV2 = patientBaseModel.fetchByIdsV2();
export const usePatientManyV2 = patientBaseModel.fetchManyV2();
export const usePatientCountV2 = patientBaseModel.countV2();
export const usePatientPaginationV2 = patientBaseModel.fetchPaginatedV2();
export const usePatientUpdateOneV2 = patientBaseModel.editV2();
export const usePatientCreateOneV2 = patientBaseModel.createV2();
export const usePatientRemoveOneV2 = patientBaseModel.deleteV2();
export const usePatientRemoveByIdsV2 = patientBaseModel.deleteByIdsV2();
